export default "../media/bg_contact_1_large.d9274e24ecbfaaa72869f7808477f5a2.jpeg";